/* eslint-disable */
import {
  SET_MOUNT_PATH_DIALOG,
  SET_USER_ACCOUNT_TYPE,
  SET_USER_CONTACT_INFO,
  SET_USER_INFO,
  SET_USER_HARDWARE,
  SET_USER_PERMISSION,
  SET_USER_ZONE,
  SET_JSON_LIST_LOADING,
  SET_JSON_CUSTOM_MADE_LIST,
} from './mutation-types'
import files from 'file-saver'
import api from '@/api'
import store from '@/store'
import { getHeaderName } from '@/utils'
import { RefundType } from '../../../constants/filters'
import { AuthStatus } from '../../../constants'

const initUserInfo = () => ({
  userName: '',
  userId: '',
  registerDate: '',
  base64ProfileImg: '',
  downloadMaxSourceFile: 1,
})

const state = {
  userContactInfo: {
    userId: '',
    phone: '',
    email: '',
    registerTime: '',
    profileImg: '',
  },
  userInfo: initUserInfo(),
  userHardware: {
    currentModels: [],
    hardwareModels: [],
    isSetModel: false,
    ram: '',
    rams: [],
    isSetRam: false,
  },
  userPermission: [],
  zone: 1, // 用于做单位切换的国内外标识
  accountType: 1, //1：主账号 2：子账号
  jsonLoading: false,
  userJsonCustomMadeList: [],
}
const mutations = {
  [SET_USER_INFO](state, payload) {
    if (payload) {
      payload.labelIds = payload.userLabels && payload.userLabels.map(item => item.id)
    }
    state.userInfo = {
      ...state.userInfo,
      ...payload,
    }
  },
  [SET_MOUNT_PATH_DIALOG](state, payload) {
    state.dialog.mountPath = {
      ...state.dialog.mountPath,
      ...payload,
    }
  },
  [SET_USER_ZONE](state, payload) {
    state.zone = payload
  },
  [SET_USER_ACCOUNT_TYPE](state, payload) {
    state.accountType = payload
  },
  [SET_USER_CONTACT_INFO](state, payload) {
    state.userContactInfo = {
      ...state.userContactInfo,
      ...payload,
    }
  },
  [SET_USER_PERMISSION](state, payload) {
    state.userPermission = payload
  },
  [SET_JSON_LIST_LOADING](state, payload) {
    state.jsonLoading = payload
  },
  [SET_JSON_CUSTOM_MADE_LIST](state, payload) {
    state.userJsonCustomMadeList = payload
  },
}

const actions = {
  // 获取用户联系方式
  async getContactInfo({ commit, state }, payload) {
    const { data } = await api.userApi.getContactInfo(payload)
    !!data && commit(SET_USER_CONTACT_INFO, data)
    return data
  },
  // 更新用户联系方式
  async updateContactInfo({ state, dispatch }, payload) {
    const { code } = await api.userApi.updateContactInfo(payload)
    return code
  },
  // 获取用户信息详情
  async queryUserDetails({ commit, state }, payload) {
    try {
      const { data } = await api.userApi.queryUserDetails(payload)
      commit(SET_USER_INFO, data)
      commit(SET_USER_ZONE, data.zone)
      commit(SET_USER_ACCOUNT_TYPE, data.accountType)
    } catch (error) {
      console.log(error)
    }
  },
  getUserDetailStatus({ state }) {
    return new Promise((resolve, reject) => {
      const unwatch = store.watch(state => state.user.userInfo.userInfo, () => {
        unwatch()
        resolve(state.userInfo)
      })
    })
  },
  resetUserDetail({ commit }) {
    commit(SET_USER_INFO, initUserInfo())
  },
  // 表单更改后同步state用户信息
  changeUserInfo({ commit }, payload) {
    commit(SET_USER_INFO, payload)
  },
  // 修改用户详情-基本信息
  async updateUserBaseInfo({ state, dispatch }, payload) {
    const data = await api.userApi.updateUserBaseInfo(payload)
    if (data.code === 200) {
      dispatch('queryUserDetails', { userId: state.userInfo.userId })
    }
    return data
  },
  // 修改用户详情-价格设置-动画价格
  async updateUserAccount({ commit }, payload) {
    const data = await api.userApi.updateUserAccount(payload)
    return data
  },
  // 修改用户详情-价格设置-账号可用金额预警
  async updateUserAccountBalancePrompt({ commit }, payload) {
    const data = await api.userApi.updateUserAccountBalancePrompt(payload)
    return data
  },
  // 查询用户详情-价格设置-云制作用户单价
  async getCloudProductionUserPrice({ commit }, payload) {
    const data = await api.userApi.getCloudProductionUserPrice(payload)
    return data
  },
  // 修改用户详情-价格设置-云制作用户单价
  async updateCloudProductionUserPrice({ commit }, payload) {
    const data = await api.userApi.updateCloudProductionUserPrice(payload)
    return data
  },
  // 修改用户详情-渲染设置
  async updateRenderSetting({ commit }, payload) {
    const data = await api.userApi.updateRenderSetting(payload)
    return data
  },
  // 修改用户详情-风险服务
  async updateRenderService({ commit }, payload) {
    const data = await api.userApi.updateRenderService(payload)
    return data
  },
  // 新创建用户标签
  async addUserTag({ commit }, payload) {
    const data = await api.userApi.addUserTag(payload)
    return data
  },
  changeMountPathDialog({ commit }, payload) {
    commit(SET_MOUNT_PATH_DIALOG, payload)
  },
  // 获取临时登录密码
  async getTempPassword({ }, payload) {
    const data = await api.userApi.getTempPassword(payload)
    return data
  },
  // 安全设置
  async setSafeList({ commit, state }) {
    let query = {
      userId: state.userInfo.userId,
    }
    const { data } = await api.userApi.setSafeList(query)
    return data
  },
  // 导出消费记录
  async exportConsumeList({ commit }, payload) {
    const { data, headers } = await api.userApi.exportConsumeList(payload)
    const fileName = getHeaderName(headers)
    const blob = new Blob([data], { type: 'application/vnd.ms-excel' })
    files.saveAs(blob, fileName)
  },
  // 导出历史重复帧
  async exportHistoryFrame({ commit }, payload) {
    const { data, headers } = await api.userApi.exportHistoryFrame(payload)
    const fileName = getHeaderName(headers)
    const blob = new Blob([data], { type: 'application/vnd.ms-excel' })
    files.saveAs(blob, fileName)
    return
  },
  // 主子账号列表
  async getUserAndSubUsers({ commit, state }, payload) {
    let query = {
      userId: state.userInfo.userId,
      pageNum: 1,
      pageSize: 50,
      ...payload,
    }
    const { data } = await api.userApi.getUserAndSubUsers(query)
    return data
    // commit(GET_USER_AND_SUB_USERS, data)
  },
  // 账号变更记录
  async getUserNameChangeRecord({ commit, state }, payload) {
    const { data } = await api.userApi.getUserNameChangeRecord(payload)
    return data
  },
  // 客户跟踪记录 --获取列表信息
  async getUserTractRecords({ }, payload) {
    const { data } = await api.userApi.showUserTractRecords(payload)
    return data
    // try {
    //   const {data} = await api.userApi.showUserTractRecords(payload)
    //   return data
    // } catch (err) {
    //   if (/\d+/.test(err.message)) {
    //     err.message.replace(/code\s(\d+)/, '$1')
    //     console.log('err: ', RegExp.$1)
    //     return RegExp.$1
    //   }
    // }
  },
  // 客户跟踪记录 --新增/编辑
  async addUserTractRecords({ }, payload) {
    const data = await api.userApi.saveOrUpdateUserTractRecord(payload)
    return data
  },
  // 客户跟踪记录删除
  async deleteUserTractRecord({ }, payload) {
    const data = await api.userApi.deleteUserTractRecord(payload)
    return data
  },
  // 开发者中心
  async getUserApi({ state }, payload) {
    // const {data} = await api.userApi.getUserApi({userName: state.userInfo.userName})
    const { data } = await api.userApi.getUserApi({ userId: state.userInfo.userId })
    return data
  },
  async setUserApi({ }, payload) {
    const { message } = await api.userApi.settUserApi(payload)
    return { message }
  },
  // 充值
  async recharge({ commit }, payload) {
    const { code, message } = await api.userApi.recharge(payload)
    if (code === 200) {
      vm.$message({
        message: message,
        type: 'success',
      })
    }
  },
  // 退款
  async refundPay({ }, payload) {
    const { code } = await api.userApi.refundPay(payload)
    vm.$message({
      message: vm.$t(`api_${code}`),
      type: code === 200 ? 'success' : 'error',
    })
  },
  // 获取充值流水
  async getRreditList({ }, payload) {
    const { data } = await api.userApi.getRreditList(payload)
    return data
  },
  // 作废订单（只针对订单状态为待确认收款）
  async invalidPayRecord({ }, payload) {
    const { data, code, result } = await api.userApi.invalidPayRecord(payload)
    return { data, code, result }
  },
  // 设置充值订单不可开票
  async setPayRecordNotInvoice({ }, payload) {
    const { data, result, code } = await api.userApi.setPayRecordNotInvoice(payload)
    return { data, result, code }
  },
  // 是否银行流水号是否重复
  async existTransactionId({ }, payload) {
    const { result } = await api.userApi.existTransactionId(payload)
    return result
  },
  // 获取退款记录
  async getRefundList({ }, payload) {
    let res = { data: [] }
    const { refundType, ...params } = payload
    if (refundType === RefundType.Render) {
      res = await api.userApi.getRefundList(params)
    } else {
      res = await api.userApi.getCopyrightRefundListByUserId(params)
    }
    return res.data
  },
  // 获取渲染券记录
  async queryUserCouponsByCondition({ }, payload) {
    const { data } = await api.userApi.queryUserCouponsByCondition(payload)
    return data
  },
  // 获取会员充值记录列表
  async queryMemberRechargesByCondition({ }, payload) {
    const { data } = await api.userApi.queryMemberRechargesByCondition(payload)
    return data
  },
  // 获取抵扣券记录列表
  async queryUserVouchersByCondition({ }, payload) {
    const res = await api.userApi.queryUserVouchersByCondition(payload)
    return res
  },
  // 获取充值记录中的渲染券记录
  async queryUserCouponsByConditionList({ }, payload) {
    const { data } = await api.userApi.queryUserCouponsByConditionList(payload)
    return data
  },
  // 使某用户渲染券失效
  async expireUserCoupons({ }, payload) {
    const data = await api.userApi.expireUserCoupons(payload)
    return data
  },
  // 使某用户渲染券永久有效
  async updateUserCouponExpire({ }, payload) {
    const data = await api.userApi.updateUserCouponExpire(payload)
    return data
  },
  // 冻结用户渲染券
  async freezeUserRenderingCoupon({ }, payload) {
    const data = await api.userApi.freezeUserRenderingCoupon(payload)
    return data
  },
  // 解冻用户渲染券
  async thawUserRenderingCoupon({ }, payload) {
    const data = await api.userApi.thawUserRenderingCoupon(payload)
    return data
  },
  // 获取aspera账号列表
  async getAsperasList({ state }) {
    const { data } = await api.userApi.getAsperasList({ userId: state.userInfo.userId })
    return data
  },
  // 新增aspera账号
  async addAsperas({ state }, payload) {
    const { data } = await api.userApi.addAsperas({
      userId: state.userInfo.userId,
      password: payload
    })
    return data
  },
  // 删除aspera账号
  async delAsperas({ state }) {
    const { data } = await api.userApi.delAsperas({ userId: state.userInfo.userId })
    return data
  },
  // 发票列表查询
  async getInvoiceList({ }, payload) {
    const result = await api.userApi.getInvoiceList(payload)
    return result
  },
  // 订单列表查询
  async getInvoiceOrder({ state }, payload) {
    let res = { data: [] }
    if (payload === RefundType.Render) {
      res = await api.userApi.getInvoiceOrder({ userId: state.userInfo.userId })
    } else {
      res = await api.userApi.queryCopyrightAvailableReceiptOrder({ userId: state.userInfo.userId })
    }
    return res.data
  },
  // 地址列表查询
  async getAddressList({ state }) {
    const { data } = await api.userApi.getAddressList({ userId: state.userInfo.userId })
    return data
  },
  async queryLastReceiptAddress({ state }, payload) {
    const { data } = await api.userApi.queryLastReceiptAddress({ userId: state.userInfo.userId, ...payload })
    return data
  },
  // 发票模板查询
  async getReceiptTemplate({ state }, payload) {
    let query = {
      userId: state.userInfo.userId,
      ...payload,
    }
    const { data } = await api.userApi.getReceiptTemplate(query)
    return data
  },
  // 发票最新模板查询
  async queryLastReceiptTemplate({ state }, payload) {
    let query = {
      userId: state.userInfo.userId,
      ...payload,
    }
    const { data } = await api.userApi.queryLastReceiptTemplate(query)
    return data
  },
  // 新增发票模板
  async addReceiptTemplate({ }, payload) {
    await api.userApi.addReceiptTemplate(payload)
    return true
  },
  // 修改发票模板
  async updateReceiptTemplate({ }, payload) {
    await api.userApi.updateReceiptTemplate(payload)
    return true
  },
  // 删除发票模板
  async delReceiptTemplate({ }, payload) {
    await api.userApi.delReceiptTemplate(payload)
    return true
  },
  // 新增收件地址
  async addReceiptAddress({ }, payload) {
    await api.userApi.addReceiptAddress(payload)
    return true
  },
  // 修改收件地址
  async updateReceiptAddress({ }, payload) {
    await api.userApi.updateReceiptAddress(payload)
    return true
  },
  // 删除收件地址
  async delReceiptAddress({ }, payload) {
    await api.userApi.delReceiptAddress(payload)
    return true
  },
  // 提交开具发票
  async receiptInvoice({ }, payload) {
    const { result, message } = await api.userApi.receiptInvoice(payload)
    return { result, message }
  },
  // 价格修改历史
  async queryPriceChangeRecord({ }, payload) {
    const { data } = await api.userApi.queryPriceChangeRecord(payload)
    return data
  },
  // 用户操作记录
  async getUserOperations({ }, payload) {
    const { data } = await api.userApi.getUserOperations(payload)
    return data
  },
  // 效果图会员变更记录
  async showPictureProByUserId({ }, payload) {
    const { data } = await api.userApi.showPictureProByUserId(payload)
    return data
  },
  // 升级效果图专业版购买记录
  async updatePicturePro({ }, payload) {
    const data = await api.userApi.updatePicturePro(payload)
    return data
  },
  // 获取当前VIP等级数据
  async getCurrentLevel({ dispatch, state }, { level }) {
    const query = {
      level,
      zone: state.userInfo.zone,
    }
    const { data } = await api.userApi.queryPriceByVipAndZone(query)
    vm.$store.dispatch('user/userInfo/changeUserInfo', data)
  },
  // 客户登录记录
  async getUserLoginInfo({ }, payload) {
    const { data } = await api.userApi.queryUserLoginInfo(payload)
    return data
  },
  // 用户解锁
  async unlockUser({ }, payload) {
    const { data } = await api.userApi.unlockUser(payload)
    return data
  },
  // 平台用户是否已导入
  async existUser({ }, payload) {
    const { code } = await api.userApi.existUser(payload)
    return code
  },
  // 根据任务号获取最大返还金额
  async getReturnAmountByTaskId({ }, payload) {
    const { data, result, code } = await api.userApi.getReturnAmountByTaskId(payload)
    return { data, result, code }
  },
  // 根据部门id查询管理员列表
  async queryAdminsByOrganizationIds({ }, payload) {
    const { data } = await api.userApi.queryAdminsByOrganizationIds(payload)
    return data
  },
  async updateMountPath({ }, payload) {
    const { code } = await api.userApi.updateMountPath(payload)
    return code
  },
  // 修改用户详情-平台渲染设置
  async updateLocalRenderSet({ commit }, payload) {
    const data = await api.userApi.updateLocalRenderSet(payload)
    return data
  },
  // 新增用户详情-平台渲染设置
  async addLocalRenderSet({ commit }, payload) {
    const data = await api.userApi.addLocalRenderSet(payload)
    return data
  },

  // 包机信息列表 查询列表
  async queryUserPackNode({ }, payload) {
    const data = await api.userApi.queryUserPackNode(payload)
    return data
  },
  // 包机信息保存或修改
  async saveOrUpdateUserPackNode({ }, payload) {
    const data = await api.userApi.saveOrUpdateUserPackNode(payload)
    return data
  },
  // 根据ID查询包机信息
  async findUserPackNode({ }, payload) {
    const data = await api.userApi.findUserPackNode(payload)
    return data
  },
  // 删除包机信息
  async deleteUserPackNode({ }, payload) {
    const data = await api.userApi.deleteUserPackNode(payload)
    return data
  },

  // 包项目信息列表 查询列表
  async queryUserPackProject({ }, payload) {
    const data = await api.userApi.queryUserPackProject(payload)
    return data
  },
  // 包项目信息保存或修改
  async saveOrUpdateUserPackProject({ }, payload) {
    const data = await api.userApi.saveOrUpdateUserPackProject(payload)
    return data
  },
  // 根据ID查询包项目信息
  async findUserPackProject({ }, payload) {
    const data = await api.userApi.findUserPackProject(payload)
    return data
  },
  // 删除包项目信息
  async deleteUserPackProject({ }, payload) {
    const data = await api.userApi.deleteUserPackProject(payload)
    return data
  },
  // 获取用户项目列表
  async getUserProjectList({ }, payload) {
    const data = await api.userApi.getUserProjectList(payload)
    return data
  },
  // 获取用户租赁列表
  async queryNodeRentals({ }, payload) {
    const data = await api.userApi.queryNodeRentals(payload)
    return data
  },
  // 添加/编辑租赁
  async addOrUpdateNodeRental({ dispatch }, payload) {
    const data = await api.userApi.addOrUpdateNodeRental(payload)
    return data
  },
  // 删除租赁
  async deleteNodeRental({ dispatch }, payload) {
    const data = await api.userApi.deleteNodeRental(payload)
    return data
  },
  // 查询用户详情-本地渲染设置
  async queryLocalRenderSets({ dispatch }, payload) {
    const { data, result } = await api.userApi.queryLocalRenderSets(payload)
    return { data, result }
  },
  // 主子账号：更新主账号总额度
  async updateTotalCredit({ dispatch }, payload) {
    const data = await api.userApi.updateTotalCredit(payload)
    return data
  },
  // 主子账号：更新主账号到期额度时间和回调金额
  async updateCreditTime({ dispatch }, payload) {
    const data = await api.userApi.setQuotaControl(payload)
    return data
  },
  // 主子账号：更新子账号额度
  async updateCredit({ dispatch }, payload) {
    const data = await api.userApi.updateCredit(payload)
    return data
  },
  // 查询子账号
  async querySubsByUserId({ dispatch }, payload) {
    const data = await api.userApi.querySubsByUserId(payload)
    return data
  },
  // 强制用户退出
  async forceLogout({ dispatch }, payload) {
    const data = await api.userApi.forceLogout(payload)
    return data
  },
  // 解除IP登录限制
  async releaseUserIpLimit({ dispatch }, payload) {
    const data = await api.userApi.releaseUserIpLimit(payload)
    return data
  },

  // 清除用户登录限制
  async cleanLoginLimit({ dispatch }, payload) {
    const data = await api.userApi.cleanLoginLimit(payload)
    return data
  },
  async queryAllUserPermission({ commit }) {
    const { data } = await api.userApi.queryAllUserPermission()
    commit(SET_USER_PERMISSION, data)
    return data
  },
  async querySubUserByMainUserId({ }, payload) {
    return await api.userApi.querySubUserByMainUserId(payload)
  },
  // 生成支付二维码
  async generateQrCodePaymentOrder({ dispatch }, payload) {
    const data = await api.userApi.generateQrCodePaymentOrder(payload)
    return data
  },
  // json文件定制列表
  async getUserJsonCustomMadeList({ commit, state }, payload) {
    try {
      commit(SET_JSON_LIST_LOADING, true)
      let { data } = await api.userApi.queryUserJsonFileCustomizationList(payload)
      commit(SET_JSON_LIST_LOADING, false)
      commit(SET_JSON_CUSTOM_MADE_LIST, data)
    } catch (error) {
      commit(SET_JSON_CUSTOM_MADE_LIST, [])
    }
  },
  // 根据id删除用户json文件定制
  async deleteUserJsonFileCustomizationById({ dispatch }, payload) {
    const data = await api.userApi.deleteUserJsonFileCustomizationById(payload)
    return data
  },
  // 根据id同步至其他平台
  async syncCurrentUserOtherPlatformById({ dispatch }, payload) {
    const data = await api.userApi.syncCurrentUserOtherPlatformById(payload)
    return data
  },
  // 根据id同步至其他账号
  async syncOtherUserPlatformById({ dispatch }, payload) {
    const data = await api.userApi.syncOtherUserPlatformById(payload)
    return data
  },
  // 社媒记录
  async getSocialMediaRecord({ state }, payload) {
    const { data } = await api.userApi.getSocialMediaRecord(payload)
    return data
  },
  // 解绑社媒
  async unbindSocialMedia({ state }, payload) {
    const res = await api.userApi.unbindSocialMedia(payload)
    return res
  },
}

const getters = {
  unit(state) {
    return state.zone === 1 ? 'RMB' : 'USD'
  },
  isRealNameAuth(state) {
    return ![AuthStatus.NoCertified, AuthStatus.Failed, AuthStatus.UnderReview, AuthStatus.PendingReview].includes(state.userInfo.authStatus)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
